<script setup lang="ts">
import { KpiChangeIndicator, changeBetween } from '@/features/dashboard'
import MoneyAmount from '@/app/components/MoneyAmount.vue'
import type { Money } from '@taler/domain'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { BreakdownRow } from '../internal/view-types.ts'
import BreakdownTable from '@/features/reporting/components/BreakdownTable.vue'
import ReportKpiCard from '@/features/reporting/components/ReportKpiCard.vue'

const props = defineProps<{
  rows: readonly BreakdownRow[]
  total: Money
  previousTotal: Money
  windowDays: number
  caption: string
  note?: string | undefined
}>()
const { t } = useI18n()
const change = computed(() => changeBetween(props.previousTotal, props.total, props.windowDays))
</script>

<template>
  <section class="flex flex-col gap-[var(--space-group)]">
    <ReportKpiCard :label="t('reporting.kpi.expenses')" icon="expense" class="max-w-md">
      <MoneyAmount :value="total" size="large" />
      <template #change>
        <KpiChangeIndicator :change="change" favourable="down" :caption="t('reporting.kpi.vsPrevious')" />
      </template>
    </ReportKpiCard>
    <BreakdownTable :rows="rows" :caption="caption" />
    <p v-if="note" class="text-[length:var(--text-step-1)] text-[color:var(--color-text-muted)]">
      {{ note }}
    </p>
  </section>
</template>
